var _rect, _g, _circle, _circle2, _circle3, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPositivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    transform: "matrix(1 0 0 -1 0 64.2964)",
    fill: "url(#paint0_linear_957_1964)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_957_1964)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 15,
    transform: "matrix(1 0 0 -1 10 74.2964)",
    fill: "#EEEEEE",
    fillOpacity: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 63,
    height: 63,
    rx: 14.5,
    transform: "matrix(1 0 0 -1 10 73.2964)",
    stroke: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 40.7964,
    r: 13.5,
    stroke: "#6EB94C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 37.7964,
    r: 1.5,
    fill: "#6EB94C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 37.7964,
    r: 1.5,
    fill: "#6EB94C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7394 43.9566C47.6137 44.5788 47.3666 45.17 47.0123 45.6967C46.6581 46.2233 46.2035 46.6751 45.6747 47.0261C45.1458 47.3771 44.553 47.6205 43.9301 47.7424C43.3072 47.8642 42.6664 47.8623 42.0443 47.7365C41.4221 47.6107 40.8309 47.3637 40.3042 47.0094C39.7775 46.6551 39.3258 46.2006 38.9748 45.6718C38.6238 45.1429 38.3804 44.5501 38.2585 43.9272",
    stroke: "#6EB94C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_957_1964",
    x: 2,
    y: 2.29639,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_957_1964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_957_1964",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_957_1964",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76CD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAFFC9",
    stopOpacity: 0.34
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositivity);
export default __webpack_public_path__ + "static/media/Positivity.5711e3e62f9e57dad649061d2121b1da.svg";
export { ForwardRef as ReactComponent };